<template>
  <div class="login">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
    >
      <h3 class="title">版灯-DCI数字版权登记平台</h3>
      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          type="text"
          auto-complete="off"
          :placeholder="usernameText"
        >
          <svg-icon
            slot="prefix"
            icon-class="user"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="password" v-if="!isverification">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon
            slot="prefix"
            icon-class="password"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="code" v-if="captchaEnabled">
        <el-input
          v-model="loginForm.code"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon
            slot="prefix"
            icon-class="validCode"
            class="el-input__icon input-icon"
          />
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img" />
        </div>
      </el-form-item>
      <el-form-item prop="verificationCode" v-if="isverification">
        <el-input
          v-model="loginForm.verificationCode"
          auto-complete="off"
          placeholder="短信验证码"
          style="width: 63%"
        >
          <svg-icon
            slot="prefix"
            icon-class="validCode"
            class="el-input__icon input-icon"
          />
        </el-input>
        <div class="register-code">
          <el-button
            @click.native.prevent="getVerificationCode"
            :disabled="isDisabled"
          >
            {{ buttonText }}</el-button
          >
        </div>
      </el-form-item>
      <el-checkbox
        v-model="loginForm.rememberMe"
        style="margin: 0px 0px 12px 0px"
        >记住密码</el-checkbox
      >
      <div class="agreement-row">
        <el-checkbox v-model="loginForm.agreePolicy">
          <span>勾选代表同意</span>
          <button
            type="button"
            class="agreement-link"
            @click.stop.prevent="openLegal"
          >
            《用户协议和隐私政策》
          </button>
        </el-checkbox>
      </div>
      <el-form-item style="width: 100%">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <el-row>
          <el-col :span="19">
            <el-button class="link-type-btn" type="text" @click="rengongkefu"
              >人工服务</el-button
            >
          </el-col>
          <el-col :span="5">
           <!--   <el-button class="link-type-btn" type="text" @click="yanzenmaLogin"
              >短信验证码登录</el-button
            > -->
            <router-link class="link-type" :to="'/register'"
              >立即注册</router-link
            >
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <span>Copyright©2024-2026中版知识产权代理（重庆）有限公司所有</span>
    </div>
  </div>
</template>

<script>
import { getCodeImg, getVerificationCode } from '@/api/login'
import Cookies from 'js-cookie'
import { encrypt, decrypt } from '@/utils/jsencrypt'

export default {
  name: 'Login',
  data () {
    return {
      codeUrl: '',
      loginForm: {
        username: '',
        password: '',
        rememberMe: false,
        agreePolicy: false,
        code: '',
        uuid: '',
        verificationCode: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', message: '请输入您的账号' }
        ],
        password: [
          { required: true, trigger: 'blur', message: '请输入您的密码' }
        ],
        code: [{ required: true, trigger: 'change', message: '请输入验证码' }],
        verificationCode: [
          { required: true, trigger: 'blur', message: '请输入验证码' }
        ]
      },
      loading: false,
      // 验证码开关
      captchaEnabled: true,
      // 注册开关
      register: true,
      redirect: undefined,
      isverification: false,
      usernameText: '账号',
      isDisabled: false, // 按钮是否禁用
      countdown: 60, // 倒计时时间
      buttonText: '获取验证码' // 按钮文本
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created () {
    this.getCode()
    this.getCookie()
    // 打开公告
    localStorage.setItem('showAnnouncement', 'true')
  },
  methods: {
    getCode () {
      getCodeImg().then(res => {
        this.captchaEnabled =
          res.captchaEnabled === undefined ? true : res.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.img
          this.loginForm.uuid = res.uuid
        }
      })
    },
    getCookie () {
      const username = Cookies.get('username')
      const password = Cookies.get('password')
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm.username =
        username === undefined ? this.loginForm.username : username
      this.loginForm.password =
        password === undefined ? this.loginForm.password : decrypt(password)
      this.loginForm.rememberMe =
        rememberMe === undefined ? false : Boolean(rememberMe)
    },
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          if (!this.loginForm.agreePolicy) {
            this.$message.warning('请先阅读并勾选用户协议和隐私政策')
            return
          }

          this.loading = true
          if (this.loginForm.rememberMe) {
            Cookies.set('username', this.loginForm.username, { expires: 30 })
            if (!this.isverification) {
              Cookies.set('password', encrypt(this.loginForm.password), {
                expires: 30
              })
            }
            Cookies.set('rememberMe', this.loginForm.rememberMe, {
              expires: 30
            })
          } else {
            Cookies.remove('username')
            if (!this.isverification) {
              Cookies.remove('password')
            }
            Cookies.remove('rememberMe')
          }
          let dataLogin = {
            username: '',
            password: '',
            rememberMe: false,
            code: '',
            uuid: '',
            verificationCode: ''
          }
          if (this.isverification) {
            dataLogin = {
              username: this.loginForm.username,
              rememberMe: false,
              code: this.loginForm.verificationCode,
              loginType: 'PHONE'
            }
          } else {
            dataLogin = {
              username: this.loginForm.username,
              password: this.loginForm.password,
              rememberMe: false,
              code: this.loginForm.code,
              uuid: this.loginForm.uuid
            }
          }
          this.$store
            .dispatch('Login', dataLogin)
            .then(() => {
              this.$router.push({ path: this.redirect || '/' }).catch(() => {})
            })
            .catch(() => {
              this.loading = false
              if (this.captchaEnabled) {
                this.getCode()
              }
            })
        }
      })
    },
    yanzenmaLogin () {
      this.getCode()
      this.usernameText = '手机号'
      this.isverification = true
    },
    rengongkefu () {
      window.open('https://work.weixin.qq.com/kfid/kfc7629f1a54ef20885')
    },
    openLegal () {
      const route = this.$router.resolve({ path: '/legal' })
      window.open(route.href, '_blank')
    },
    async getVerificationCode () {
      if (this.loginForm.code && this.loginForm.username) {
        //         /sms/temp/{type}
        // String phone 手机号
        // String captchaUuid 图形验证码id
        // String captchaCode 图形验证码用户填写值
        // 这个是发送短信的接口，type固定值reg、login、dci，分别对应注册、登录、dci申领支付
        let upbadge = new FormData()
        upbadge.append('phone', this.loginForm.username)
        upbadge.append('captchaUuid', this.loginForm.uuid)
        upbadge.append('captchaCode', this.loginForm.code)
        const res = await getVerificationCode(upbadge, 'login')
        if (res.code == 200) {
          this.$message({
            message: '验证码已发送',
            type: 'success'
          })
          // 禁用按钮
          this.isDisabled = true
          // 启动倒计时
          const timer = setInterval(() => {
            this.countdown--
            this.buttonText = `${this.countdown}秒后重试`

            // 倒计时结束
            if (this.countdown <= 0) {
              clearInterval(timer) // 清除定时器
              this.isDisabled = false // 启用按钮
              this.buttonText = '获取验证码' // 恢复按钮文本
              this.countdown = 60 // 重置倒计时时间
            }
          }, 1000)
        }
        console.log('短信验证码--------', res)
      } else {
        this.$message({
          message: '请输入手机号和图形验证码',
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style rel="scss" lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url('../assets/images/login-background.jpg');
  background-size: cover;
}

.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
  font-weight: bold;
  font-size: 20px;
  line-height: 1;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;

  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.login-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}

.login-code-img {
  height: 38px;
}

.el-button--text {
  margin-right: 20px;
}

.agreement-row {
  margin: 0 0 18px;
  color: #606266;
  font-size: 13px;
  line-height: 1.4;
}

.agreement-row .el-checkbox {
  display: flex;
  align-items: center;
  white-space: normal;
}

.agreement-row .el-checkbox__label {
  color: #606266;
  font-size: 13px;
  line-height: 1.4;
}

.agreement-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: #409eff;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.4;
}

.agreement-link:hover {
  color: #66b1ff;
}
</style>
